/*
 * Module for the Online Forms list
*/
rs.module("content/communications/onlineforms",

    [
        "layouts/filedownload",
        "controls/components/event-banner",
        "ui/framework/client-templates"
    ],

    function (fileDownload, eventBanner, clientTemplates) {

        // the current download action
        var _formExecute = null;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, templateKeys, listApi) {

            var modal = $.js(jsSelectors.promptModal)

            if (backendUrls.downloadForm) {
                window.location.href = backendUrls.downloadForm;
            }

            listApi.onItemClick(function (e, context) {

                // Capture everything needed for the delayed operations to come
                var downloadLink = $(this)[0];
                var eformUrl = $(this)[0].href;
                var formId = context.Id;
                var isFileDownload = context.IsFileDownload;

                // Function for invoking the form selected. This will either be executed immediately
                // or once the modal is closed, in the case of a prompt message being configured for display
                _formExecute = function () {

                    // if this was an eform, do the redirect to the custom page
                    if (eformUrl) {
                        // do the delayed redirect
                        window.location.href = eformUrl;
                    }
                    else if (isFileDownload) {
                        fileDownload.initiateDownload(downloadLink, {
                            onstart: function () {
                                $(downloadLink).addClass("_executing");
                            },
                            oncomplete: function () {
                                $(downloadLink).removeClass("_executing");
                            }
                        });

                        // hide the modal
                        modal.modal('hide');
                    }
                }

                if (eformUrl) {
                    e.preventDefault();
                }

                // Make a call to find out if we need any input for the form
                $.ajax({
                    url: backendUrls.getFormPromptDetails,
                    data: { formId: formId },
                }).done(function (data) {

                    if (data) {
                        var promptHeader = isFileDownload ? "Form Download" : "Electronic Form";
                        var promptText = data.prompt;
                        var promptAddendum = null;
                        var selectionRequired = false;

                        // update the header
                        modal.js(jsSelectors.promptHeader).html(promptHeader);

                        // reset the message and addendum text
                        modal.js(jsSelectors.promptMessage).removeClass("d-none");
                        modal.js(jsSelectors.promptMessage).text(promptText);
                        modal.js(jsSelectors.promptAddendum).removeClass("d-none");
                        modal.js(jsSelectors.promptAddendum).text('');

                        // remove any listening close events
                        modal.off('hidden.bs.modal');

                        // clear any pre-existing fund and benefits
                        modal.js(jsSelectors.fundList).html('');
                        modal.js(jsSelectors.benefitList).html('');

                        var singleFundKey = null;
                        var singleBenefitClaimPaymentKey = null;

                        if (data.funds && data.funds?.length > 0) {

                            if (data.funds.length == 1) {
                                // there's a single fund, we are NOT going to show it to them
                                selectionRequired = false;

                                singleFundKey = data.funds[0].fundKey;
                            }
                            else {
                                // render the contents for the list of funds and add it to the modal
                                var content = clientTemplates.render(templateKeys.fund, { "funds": data.funds });
                                modal.js(jsSelectors.fundList).html(content);

                                promptAddendum = "Which fund does this form apply to?";

                                selectionRequired = true;
                            }

                        }
                        else if (data.benefitClaimPayments) {

                            if (data.benefitClaimPayments.length == 0) {
                                // we likely filtered out terminated and none are left, so we're just going to change
                                // the prompt to a nice message saying Sorry!  If it's even possible, it's highly unlikely

                                promptText = "Sorry, there are no benefits available for this form.";
                                selectionRequired = false;

                                // clear any form execution
                                _formExecute = null;
                            }
                            else if (data.benefitClaimPayments.length == 1) {
                                // there's a single benefit, we are NOT going to show it to them
                                selectionRequired = false;

                                singleBenefitClaimPaymentKey = data.benefitClaimPayments[0].benefitClaimPaymentKey
                            }
                            else {
                                // render the contents for the list of benefits and add it to the modal
                                var content = clientTemplates.render(templateKeys.benefit, { "benefits": data.benefitClaimPayments });
                                modal.js(jsSelectors.benefitList).html(content);

                                promptAddendum = "Which benefit does this form apply to?";

                                selectionRequired = true;
                            }
                        }

                        if (promptText || promptAddendum) {

                            if (selectionRequired) {
                                // stash the formid on the form so it can be used
                                modal.data("formid", formId);

                                // Remove the previous click handler
                                modal.js(jsSelectors.promptButton).off('click');

                                // update the prompt button to "Close", since clicking it will close the modal (the user must click one of the selection links to continue)
                                modal.js(jsSelectors.promptButton).text("Close").click(function () {

                                    // when closing, remove the saved action so it isn't initiated in the hidden.bs.modal handler
                                    _formExecute = null;
                                });
                            }
                            else {

                                // Remove the previous click handler
                                modal.js(jsSelectors.promptButton).off('click');

                                // update the prompt button to "OK", since clicking it will proceed forward (downloading or redirecting)
                                modal.js(jsSelectors.promptButton).text("OK").click(function () {

                                    // if we have a single fund or benefit defaulted, just execute with those values
                                    if (singleFundKey || singleBenefitClaimPaymentKey) {
                                        executeFormWithCriteria(formId, singleFundKey, singleBenefitClaimPaymentKey);
                                    }
                                    else {
                                        if (_formExecute) {
                                            _formExecute();
                                        }
                                    }
                                });
                            }

                            // update the prompt text 
                            if (promptText?.length > 0) {
                                modal.js(jsSelectors.promptMessage).html(promptText);
                            }
                            else {
                                modal.js(jsSelectors.promptMessage).addClass("d-none");
                            }

                            // update the addendum text
                            if (promptAddendum?.length > 0) {
                                modal.js(jsSelectors.promptAddendum).html(promptAddendum);
                            }
                            else {
                                modal.js(jsSelectors.promptAddendum).addClass("d-none");
                            }

                            // show the prompt
                            modal.modal("show");
                        }
                        else {
                            // if we have a single fund or benefit defaulted, just execute with those values
                            if (singleFundKey || singleBenefitClaimPaymentKey) {
                                executeFormWithCriteria(formId, singleFundKey, singleBenefitClaimPaymentKey);
                            }
                            else {
                                _formExecute();
                            }
                        }
                    }
                }).fail(function (xhr, status, error) {
                    eventBanner.addErrorMessages("An error occurred while trying to retrieve the form details: " + error);
                });
            });

            modal.onjs("click enterpressed", jsSelectors.promptSelectionLink, function (e) {

                var formId = modal.data("formid");
                var fundKey = $(this).data("fundkey");
                var bcpKey = $(this).data("benefitclaimpaymentkey");

                executeFormWithCriteria(formId, fundKey, bcpKey);
            });

            // Executes the form with the selected criteria
            function executeFormWithCriteria(formId, fundKey, bcpKey) {
                var requestData = {
                    formId: formId,
                    fundKey: fundKey,
                    benefitclaimpaymentkey: bcpKey
                };

                if (_formExecute) {
                    $.ajax({
                        url: backendUrls.captureFormCriteria,
                        data: requestData
                    }).done(function () {
                        // Now invoke the download, which will pass along the received/captured form criteria 
                        // the form of redirect state
                        _formExecute();
                    });
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);